import format from 'date-fns/format';
import getYear from 'date-fns/getYear';
import parse from 'date-fns/parse';
import startOfToday from 'date-fns/startOfToday';
import isValid from 'date-fns/isValid';
import React, { Fragment } from 'react';
import isEmpty from 'lodash/isEmpty';
import HorizontalMenu from '../HorizontalMenu';
import TableSelectorBack from '../TableSelector/TableSelectorBack';
import Styled from './styles';
import useNav from '../../../hooks/useNav';
import useTranslate from '../../../hooks/useTranslate';
import { getTimeFormat } from '../../../helpers/dates';
import MobileHide from '../../../shared/components/MobileHide';
import Prices from '../Prices';

interface Props {
  layoutState: {
    isFullscreen: boolean;
    isFailure: boolean;
    previewMode: boolean;
    schemeMode: boolean;
  };
}

const Nav = ({ layoutState }: Props) => {
  const { Widget } = window;
  const { i18n } = useTranslate();
  const { state, selectedDate } = useNav({ i18n });
  const { meta, sector, locale } = state;
  const { isFullscreen, isFailure, previewMode, schemeMode } = layoutState;

  if (isEmpty(meta)) return null;
  const currentDate = selectedDate || meta.datetime;

  const parsedDate = parse(
    `${currentDate}`,
    'yyyy-MM-dd HH:mm:SS',
    // @ts-ignore
    new Date(),
  );
  const currentYear = getYear(startOfToday());
  const eventYear = getYear(parsedDate);
  const timeFormat = getTimeFormat(Widget.settings.convertToAmPmTime, Widget.settings.lang);
  const formatDate =
    currentYear === eventYear
      ? `EEEEEE, d MMMM, ${timeFormat}`
      : `EEEEEE, d MMMM yyyy, ${timeFormat}`;
  const date = isValid(parsedDate) ? format(parsedDate, formatDate, { locale }) : null;

  const { isPeriodical } = Widget.metaController.meta;
  const {
    title,
    place: { title: placeName },
  } = meta;

  return (
    <Styled.NavWrapper
      onMouseMove={(e) => {
        e.stopPropagation();
      }}
      schemeMode={schemeMode}
    >
      <Styled.Nav isFullscreen={isFullscreen} isPeriodical={isPeriodical}>
        <Styled.Container isPeriodical={isPeriodical}>
          {sector ? <TableSelectorBack sector={sector} /> : null}

          {!sector && isPeriodical ? (
            <Fragment>
              <Styled.NameWrapper>
                <Styled.Name inline>{title}</Styled.Name>
              </Styled.NameWrapper>

              <Styled.Place inline>{placeName}</Styled.Place>
            </Fragment>
          ) : null}

          {!sector && !isPeriodical ? (
            <Fragment>
              <Styled.WidthHelper>
                <Styled.NameWrapper>
                  <Styled.Name>{title}</Styled.Name>
                </Styled.NameWrapper>
                {date && <Styled.Date>{date}</Styled.Date>}
              </Styled.WidthHelper>

              <Styled.Place>{placeName}</Styled.Place>
              {date && <Styled.Date mobile>{date}</Styled.Date>}
            </Fragment>
          ) : null}
        </Styled.Container>
      </Styled.Nav>

      {meta.dates && <HorizontalMenu dates={meta.dates} />}

      {!previewMode && !isFailure && (
        <MobileHide isFullscreen={isFullscreen}>
          <Prices isFullscreen={isFullscreen} schemeMode={schemeMode} />
        </MobileHide>
      )}
    </Styled.NavWrapper>
  );
};

// @ts-ignore
export default Nav;
